import React from "react";
import { Router, Route, IndexRoute, hashHistory } from "react-router";
import Layout from "../Layout/Layout";
import AsyncRoute from "./AsyncRoute";
import Services from "../Services/Services";
import ContactUs from "../ContactUs/ContactUs";
import DataPolicy from "../Footer/DataPolicy";
import ScaleHighs from "../Services/ScaleHighs";
import OurTeam from "../OurTeam/OurTeam";

class Routes extends React.Component {
  render() {
    return (
      <Router history={hashHistory}>
        <Route
          path="/Login"
          component={(props) => (
            <AsyncRoute
              props={props}
              loadingPromise={System.import("../Layout/OuterLayout")}
            />
          )}
        >
          <IndexRoute
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Login/Login")}
              />
            )}
          />
          {/* <Route path='/main' component={(props) => <AsyncRoute props={props} loadingPromise={System.import('../MainPage/MainPage')} />} /> */}

          <Route
            exact
            path="/Main"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../MainPage/Main")}
              />
            )}
          />
          <Route
            path="/Register"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Login/Register")}
              />
            )}
          />
          <Route
            path="/BusinessLogin"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../BusinessLogin/Login")}
              />
            )}
          />
          <Route
            path="/BusinessRegister"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../BusinessLogin/Register")}
              />
            )}
          />
          <Route
            path="/adminLogin"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../AdminLogin/LoginRegistration"
                )}
              />
            )}
          />
          <Route
            path="/emailverification/:token"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../EmailVerification/EmailVerification"
                )}
              />
            )}
          />
          <Route
            path="/businessemailverification/:token"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../EmailVerification/BusinessEmailVerification"
                )}
              />
            )}
          />
          <Route
            path="/confirmRequest/:token"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../EmailVerification/RequestVerification"
                )}
              />
            )}
          />
          <Route
            path="/resetpassword/verify/:token"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../ChangePassword/ChangePassword"
                )}
              />
            )}
          />
          <Route
            path="/businessresetpassword/verify/:token"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../ChangePassword/BusinessChangePassword"
                )}
              />
            )}
          />
          <Route
            path="/registration"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Login/Register")}
              />
            )}
          />
          {/* <Route path='/feedBacks' component={(props) => <AsyncRoute props={props} loadingPromise={System.import('../FeedBacks/FeedBacks')}/>} /> */}
          <Route
            path="/contactUs"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../ContactUs/ContactUs")}
              />
            )}
          />
          <Route
            path="/ITStaff"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../ITStaff/ITStaff")}
               
              />
            )}
          />
          <Route
            path="/ITProjects"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../ITProjects/ITProjects")}
              />
            )}
          />
          <Route
            path="/EasyPraxis"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../EasyPraxis/EasyPraxis")}
              />
            )}
          />
          <Route
            path="/EasyPraxis"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../EasyPraxis/EasyPraxisOld")}
              />
            )}
          />
          <Route
            path="/Elearning"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Elearning/Elearning")}
              />
            )}
          />
          <Route
            path="/DigitalFirst"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../DigitalFirst/DigitalFirst")}
              />
            )}
          />
          <Route
            path="/EasyPraxis"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../EasyPraxis/EasyPraxis")}
              />
            )}
          />
          <Route
            path="/Cloud"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Cloud/Cloud")}
              />
            )}
          />
          <Route
            path="/aboutUs"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../AboutUs/AboutUs")}
              />
            )}
          />
          <Route
            path="/services"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Services/Services")}
              />
            )}
          />
          <Route
            path="/contactUs"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../ContactUs/ContactUs")}
              />
            )}
          />
         
         
          <Route
            path="/notfall"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Pages/Notfall")}
              />
            )}
          />
          <Route
           path="/leitgedanken"
           component={(props) => (
             <AsyncRoute
               props={props}
               loadingPromise={System.import("../Pages/Leitgedanken")}
             />
           )}
         />
           <Route
            path="/physiotherapie"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Pages/Physiotherapie")}
              />
            )}
          />
          {/* <Route
          path="/sonographie"
          component={(props) => (
            <AsyncRoute
              props={props}
              loadingPromise={System.import("../Pages/Sonographie")}
            />
          )}
        /> */}
        <Route
        path="/venensprechstunde"
        component={(props) => (
          <AsyncRoute
            props={props}
            loadingPromise={System.import("../Pages/Venensprechstunde")}
          />
        )}
      />
      <Route
        path="/rheumatologie"
        component={(props) => (
          <AsyncRoute
            props={props}
            loadingPromise={System.import("../Pages/Rheumatologie")}
          />
        )}
      />

          <Route
            path="/dataPolicy"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Footer/DataPolicy")}
              />
            )}
          />
      
      <Route
      path="/wirBildenAus"
      component={(props) => (
        <AsyncRoute
          props={props}
          loadingPromise={System.import("../Pages/WirBildenAus")}
        />
      )}
    />
    <Route
    path="/impressionenPraxis"
    component={(props) => (
      <AsyncRoute
        props={props}
        loadingPromise={System.import("../Pages/ImpressionenPraxis")}
      />
    )}
  />
        <Route
        path="/ernahrungsberatung"
        component={(props) => (
          <AsyncRoute
            props={props}
            loadingPromise={System.import("../Pages/Ernahrungsberatung")}
          />
        )}
      />
            <Route
            path="/hausarztliche"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Pages/Hausarztliche")}
              />
            )}
          />
          <Route
          path="/medizinisches"
          component={(props) => (
            <AsyncRoute
              props={props}
              loadingPromise={System.import("../Pages/MedizinischesAngebot")}
            />
          )}
        />
           <Route
            path="/quickLinks"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Pages/QuickLinks")}
              />
            )}
          />
          {/* QuickLinks */}
          <Route path="/scaleHighs" component={ScaleHighs} />
          <Route path="/dataPolicy" component={DataPolicy} />
          
          <Route path="/ourTeam" component={OurTeam} />
          <Route
            path="/cookiesPolicy"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Footer/CookiesPolicy")}
              />
            )}
          />
          <Route
            path="/termsOfUse"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Footer/TermsOfUse")}
              />
            )}
          />
          <Route
            path="/legalDisclaimer"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Footer/LegalDisclaimer")}
              />
            )}
          />
          <Route
            path="/dataPolicy"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Footer/DataPolicy")}
              />
            )}
          />
          <Route
            path="/privatePolicy"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Footer/PrivatePolicy")}
              />
            )}
          />
          
           
          
          <Route
            path="/customers"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Customers/Customers")}
              />
            )}
          />
          <Route
            path="/partners"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Partners/partners")}
              />
            )}
          />
          <Route
            path="/offices"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Offices/Offices")}
              />
            )}
          />
          <Route
            path="/testimonials"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Testimonials/Testimonials")}
              />
            )}
          />
            <Route
            path="/news"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../AdminNews/News")}
              />
            )}
          />
        </Route>
        
        <Route
          path="/"
          component={(props) => (
            <AsyncRoute
              props={props}
              loadingPromise={System.import("../Layout/Layout")}
            />
          )}
        >
          <IndexRoute
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Dashboards/Dashboards")}
              />
            )}
          />
          {/* <IndexRoute component={(props) => <AsyncRoute props={props} loadingPromise={System.import('')}/> } /> */}
          {/* <Route path='/supplierMasterData' component={(props) => <AsyncRoute props={props} loadingPromise={System.import('../SupplierMasterData/SupplierMasterDataTabel')}/>} /> */}
          <Route
            path="/editProfile"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../EditProfile/BusinessEditProfile"
                )}
              />
            )}
          />
          <Route
            path="/editBusiness"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../EditBusiness/EditBusiness")}
              />
            )}
          />
          <Route
            path="/resetPassword"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../ResetPassword/ResetPassword")}
              />
            )}
          />

          <Route
            path="/labelAndTranslation"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../LabelAndTranslation/LabelAndTranslation"
                )}
              />
            )}
          />
          <Route
            path="/profileAudit"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../ProfileAuditAndHistory/ProfileAudit"
                )}
              />
            )}
          />
          <Route
            path="/profileHistory"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../ProfileAuditAndHistory/ProfileHistory"
                )}
              />
            )}
          />
          <Route
            path="/drugMasterAudit"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../ProfileAuditAndHistory/DrugMasterAudit"
                )}
              />
            )}
          />
          <Route
            path="/drugMasterHistory"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../ProfileAuditAndHistory/DrugMasterHistory"
                )}
              />
            )}
          />
          <Route
            path="/settings"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Settings/Settings")}
              />
            )}
          />
          <Route
            path="/drugMasterUpload"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../AdminData/AdminData")}
              />
            )}
          />
          <Route
            path="/drugMaster"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../AdminData/DrugMaster")}
              />
            )}
          />
          <Route
            path="/businessSetting"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../AdminData/BusinessSetting")}
              />
            )}
          />
          <Route
            path="/dashboard"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Dashboards/MemberDashboard")}
              />
            )}
          />

          <Route
            path="/subscription"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Subscription/Subscription")}
              />
            )}
          />
          <Route
            path="/editSubscription"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../Subscription/EditSubscription"
                )}
              />
            )}
          />

          <Route
            path="/userManagement"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../userManagement/userManagement"
                )}
              />
            )}
          />
          <Route
            path="/adminfeedbacks"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../FeedBacks/AdminFeedback")}
              />
            )}
          />
          <Route
            path="/feedback"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../FeedBacks/FeedBacks")}
              />
            )}
          />
          <Route
            path="/contact"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../ContactUs/ContactUs")}
              />
            )}
          />
          {/* <Route path='/ITresource' component={(props) => <AsyncRoute props={props} loadingPromise={System.import('../MainPage/ITresource')} />} /> */}
          <Route
            path="/about"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../AboutUs/AboutUs")}
              />
            )}
          />
          <Route
            path="/cookiespolicy"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Footer/CookiesPolicy")}
              />
            )}
          />
          <Route
            path="/termsofuse"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Footer/TermsOfUse")}
              />
            )}
          />
          <Route
            path="/legaldisclaimer"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Footer/LegalDisclaimer")}
              />
            )}
          />
          <Route
            path="/privatepolicy"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Footer/PrivatePolicy")}
              />
            )}
          />
          <Route
            path="/dataprivacy"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Footer/DataPolicy")}
              />
            )}
          />
          <Route
            path="/customerlist"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Customers/Customers")}
              />
            )}
          />
          <Route
            path="/partnerlist"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Partners/Partners")}
              />
            )}
          />
          <Route
            path="/officelist"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Offices/Offices")}
              />
            )}
          />
          <Route
            path="/ITStaffAdmin"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../ITStaff/ITStaff")}
              />
            )}
          />
          <Route
            path="/ITProjectsAdmin"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../ITProjects/ITProjects")}
              />
            )}
          />
          <Route
            path="/ElearningAdmin"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Elearning/Elearning")}
              />
            )}
          />
          <Route
            path="/DigitalFirstAdmin"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../DigitalFirst/DigitalFirst")}
              />
            )}
          />
          <Route
            path="/CloudAdmin"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Cloud/Cloud")}
              />
            )}
          />
          <Route
            path="/healthHistory"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../HealthHistory/HealthHistory")}
              />
            )}
          />
          <Route
            path="/health"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../HealthHistory/HealthUser")}
              />
            )}
          />
          <Route
            path="/BusinessSettingCustomColumn"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../AdminSettings/CustomColumnChange"
                )}
              />
            )}
          />
          <Route
            path="/masterSubscription"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import(
                  "../Subscription/MasterSubscription"
                )}
              />
            )}
          />
          <Route
            path="/TestimonialsAdmin"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../Testimonials/Testimonials")}
              />
            )}
          />
           <Route
            path="/NewsAdmin"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../AdminNews/News")}
              />
            )}
          />

          <Route
            path="/contactUsAdmin"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../ContactUs/ContactUsAdmin")}
              />
            )}
          />

          <Route
            path="/businessProfile"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../EditBusiness/EditBusiness")}
              />
            )}
          />
          <Route
            path="/adminTeams"
            component={(props) => (
              <AsyncRoute
                props={props}
                loadingPromise={System.import("../AdminTeams/AdminTeams")}
              />
            )}
          />
        </Route>
      </Router>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./screens/Routes/Routes.js